import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import MobileBottomNav from "components/navbar/MobileBottomNav";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";
import useBreadcrumbs from "hooks/useBreadcrumbs";
import { isAuthenticated } from "utils/auth";
import { stripPortalBasePath, getDefaultPortalPath } from "utils/portalPath";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(() =>
    typeof window !== "undefined" ? window.innerWidth >= 1200 : true
  );
  const breadcrumbItems = useBreadcrumbs();
  const brandText = React.useMemo(() => breadcrumbItems.join(" / "), [breadcrumbItems]);

  React.useEffect(() => {
    const handleResize = () => {
      setOpen(window.innerWidth >= 1200);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const matchRoutePath = (currentPath, routePath) => {
    if (!routePath) return false;
    const normalizedCurrent = currentPath.replace(/^\//, "");
    const normalizedRoute = routePath.replace(/^\//, "");
    const regexSegments = normalizedRoute.split("/").map((segment) => {
      return segment.startsWith(":") ? "[^/]+" : segment.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    });
    const regex = new RegExp(`^${regexSegments.join("/")}(?:/|$)`);
    return regex.test(normalizedCurrent);
  };

  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    const currentPath = stripPortalBasePath(window.location.pathname).replace(/^\//, "");
    for (let i = 0; i < routes.length; i++) {
      if (matchRoutePath(currentPath, routes[i].path)) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={prop.path} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
        >
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"Horizon UI Tailwind React"}
              brandText={brandText}
              secondary={getActiveNavbar(routes)}
              {...rest}
            />
            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {getRoutes(routes)}
                  <Route
                    path="/"
                    element={<Navigate to={getDefaultPortalPath() + "/dashboard"} replace />}
                  />

                  {/* Catch-all for unknown admin routes: redirect based on auth */}
                  <Route
                    path="*"
                    element={
                      <Navigate to={isAuthenticated() ? getDefaultPortalPath() + "/dashboard" : "/auth/sign-in"} replace />
                    }
                  />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
      <MobileBottomNav />
    </div>
  );
}
